//Local imports
import XiQLightLogo from "../../../../../assets/img/Loaders/XiQLightLogo.png";
import styled from "styled-components";

const TemplateCardPlaceholder = (props: any) => {
  return (
    <>
      <Wrapper>
        <div className="sk-container">
          <div className="thumb skeleton-box">
            <img src={XiQLightLogo} className="profile-img" />
          </div>
          <span className="template-name"></span>
        </div>
      </Wrapper>
    </>
  );
};

export default TemplateCardPlaceholder;

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
  margin: 10px 0;
  cursor: pointer;
  position: relative;
  .thumb {
    width: 100%;
    height: 130px;
    overflow: hidden;
    box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);
    img {
      width: 100%;
    }
  }

  span.template-name {
    color: #424b50;
    font-size: 14px;
    font-family: "Roboto Slab", serif;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    width: 100%;
    min-height: 46px;
    -webkit-box-align: start;
    transition-duration: 0.5s;
  }
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0px;
    margin: 0;
    .clear {
      clear: both;
    }
    .skeleton-box {
      display: inline-block;
      height: 130px;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.radius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }

    .img-container {
      width: 10%;
      padding: 15px;
      display: flex;
    }
  }
`;
